import { API_URL } from "@/env";
import { CMO_DetailAPI, CMO_StatsAPI, CMOListAPI } from "./type";

async function getCmoList(page: number = 1, per_page: number = 10, search?: string, range?: 'under_1b' | '1b_to_2b' | 'over_2b' | '', status?: 'active' | 'inactive' | '') : Promise<CMOListAPI> {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No token found');
    }
    try {
        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
        });
        if (search?.trim()) {
            queryParams.append('search', search);
        }
        if (range && range.trim()) {
            queryParams.append('revenue_range', range);
        }
        if (status && status.trim()) {
            queryParams.append('status', status);
        }
        const response = await fetch(`${API_URL}/api/v1/be/admin/cmo?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch CMO list');
        }
        return await response.json() as CMOListAPI;
    } catch (error) {
        console.error('Error fetching CMO list:', error);
        throw error;
    }
}

async function getCmoStats(): Promise<CMO_StatsAPI> {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No token found');
    }
    try {
        const response = await fetch(`${API_URL}/api/v1/be/admin/cmo/stats`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch CMO stats');
        }
        return await response.json() as CMO_StatsAPI;
    } catch (error) {
        console.error('Error fetching CMO stats:', error);
        throw error;
    }
}

async function getCmoDetail(cmoId: number, page: number = 1, per_page: number = 10, search?: string, status?: 'active' | 'inactive' | 'transfer' | 'expired' | '', is_transfer?: boolean) : Promise<CMO_DetailAPI> {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No token found');
    }
    try {      
        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
        });
        if (search?.trim()) {
            queryParams.append('search', search);
        }
        if (status && status.trim()) {
            queryParams.append('status', status);
        }
        if (is_transfer !== undefined) {
            queryParams.append('transfer_type', is_transfer ? 'transfer' : 'original');
        }
        const response = await fetch(`${API_URL}/api/v1/be/admin/cmo/${cmoId}?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch CMO detail');
        }
        return await response.json() as CMO_DetailAPI;
    } catch (error) {
        console.error('Error fetching CMO detail:', error);
        throw error;
    }
}

export {
    getCmoList,
    getCmoStats,
    getCmoDetail,
};